export const capitalizeFirstLetter = (string) => {
	return string.charAt(0).toUpperCase() + string.slice(1);
};

export const normalizeValue = (value) => {
	return typeof value === "string" ? value.trim() : value;
};

export const castToBoolean = (value) => {
	if (typeof value === "string") {
		return value.toLowerCase() === "true" ? true : false;
	}
	if (typeof value === "boolean") {
		return value;
	}
	return false;
};
